<template>

  <div ref="container" :class="{ 'active' : active }"></div>

</template>


<script type="text/babel">

import lottie from 'lottie-web';
import scrollmonitor from 'scrollmonitor'

export default {

  data() {
    return {
      active: false,
      animationObj: {}
    }
  },

  mounted() {
    let vm = this;
    vm.createAnimation();
    vm.createWatcher();
    Event.listen('reset-animations', () => { this.reset(); })
  },

  props: {
    path: { type: String, default: '' },
    loop: { type: Boolean, default: false }
  },

  computed: {},

  methods: {
    createAnimation(){
      let vm = this, anim;

      anim = lottie.loadAnimation({
        container: vm.$refs.container,
        renderer: 'svg',
        autoplay: false,
        loop: vm.loop,
        path: vm.path
      });

      vm.animationObj = anim;
    },

    createWatcher(){
      let vm = this;
      var offset = -Math.abs(window.innerHeight * 0.1);
      var elWatcher = scrollmonitor.create(vm.$el, offset );

      elWatcher.enterViewport(function(){
        vm.setActiveState(true)
        vm.animationObj.play();
      });
    },

    setActiveState(b){
      if(b){ this.active = true };
      if(!b){ this.active = false };
    },

    reset(){
      this.setActiveState(false);
      this.animationObj.goToAndStop(0);
    }
  }
}

</script>
